import { render, staticRenderFns } from "./_base-nav-breadcrumb.vue?vue&type=template&id=5ef82f13&"
import script from "./_base-nav-breadcrumb.vue?vue&type=script&lang=js&"
export * from "./_base-nav-breadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./_base-nav-breadcrumb.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports